/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
// slices
import configStatus from 'state/reducers/ratingsState/configStatus';
import analyticsStatus from 'state/reducers/ratingsState/analyticsStatus';
import addOnsStatus from 'state/reducers/ratingsState/addOnsStatus';
import ratingsStatus from 'state/reducers/ratingsState/ratingsStatus';
import codeStatus from 'state/reducers/ratingsState/codeStatus';
/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const rootReducer = combineReducers({
    configStatus,
    analyticsStatus,
    addOnsStatus,
    ratingsStatus,
    codeStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rootReducer;
